// put in separate file because of circular dependency
export const TeamTabId = "sidebar-teams";
